import axios from 'axios';

// Set to false to use the real API
const useMockData = false;

//const API_URL = process.env.REACT_APP_API_URL || 'https://icy-hill-43c1.bchawks.workers.dev';
const API_URL = 'https://colinstebelski.com';

// Create axios instance
const api = axios.create({
  baseURL: 'https://colinstebelski.com',
  withCredentials: true,
});


// Add a request interceptor to add the auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Auto logout if 401 or 403 response returned from API
      authService.logout();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Mock data for testing
const mockVideos = [
  { id: 1, title: 'Family Vacation 2023', date: '2023-07-15' },
  { id: 2, title: 'Birthday Party', date: '2023-04-22' },
  { id: 3, title: 'Christmas Morning', date: '2022-12-25' },
  { id: 4, title: 'Graduation Day', date: '2023-06-10' },
  { id: 5, title: 'Wedding Anniversary', date: '2023-08-05' }
];

// Authentication services
export const authService = {
  login: async (password) => {
    if (useMockData) {
      // For testing, accept any password
      localStorage.setItem('token', 'mock-token');
      return true;
    }
    
    try {
      const response = await api.post('/api/login', { password });
      
      if (response.data && response.data.token) {
        localStorage.setItem('token', response.data.token);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error('Login error:', error.message);
      if (error.response) {
        console.error('Error response:', error.response.status, error.response.data);
      }
      throw error;
    }
  },
  
  logout: () => {
    localStorage.removeItem('token');
  },
  
  isAuthenticated: () => {
    return localStorage.getItem('token') !== null;
  }
};

// Video services
export const videoService = {
  getAllVideos: async () => {
    if (useMockData) {
      return mockVideos;
    }
    
    try {
      const response = await api.get('/api/videos');
      // Extract the videos array from the response
      if (response.data && response.data.videos) {
        return response.data.videos;
      } else {
        console.warn('Unexpected API response format:', response.data);
        return [];
      }
    } catch (error) {
      console.error('Error fetching videos:', error);
      throw error;
    }
  },
  
  getVideo: async (id) => {
    if (useMockData) {
      const video = mockVideos.find(v => v.id === id);
      if (video) {
        return {
          ...video,
          description: `This is a mock description for video ${id}.`
        };
      }
      throw new Error('Video not found');
    }
    
    // Since we don't have a /api/videos/:id endpoint, 6
    // construct a video object from the id
    try {
      // Create a basic video object from the ID
      let title = id;
      // Remove extension if present
      if (title.includes('.')) {
        title = title.substring(0, title.lastIndexOf('.'));
      }
      // Convert snake_case or kebab-case to spaces
      title = title.replace(/[_-]/g, ' ');
      // Capitalize first letter of each word
      title = title.split(' ').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
      
      return {
        id: id,
        title: title,
        date: new Date().toISOString().split('T')[0],
        description: 'Video playback'
      };
    } catch (error) {
      console.error(`Error creating video object for ${id}:`, error);
      throw error;
    }
  },
  
  getVideoStreamUrl: (id) => {
    if (useMockData) {
      // Return a sample video URL for testing
      return 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4';
    }
    
    // Simply return the URL - the auth header will be added automatically
    // by the fetch API or through the video element's loadstart handler
    return `${API_URL}/api/stream/${id}`;
  }
};

export default api; 